module.exports = new __parcel__URL__("hercules.851e22fa.png").toString();